<template>
  <b-container>
    <b-navbar variant="primary" class="d-flex justify-content-center">
      <b-navbar-brand class="text-light font-weight-bold"
        >捐款回報</b-navbar-brand
      >
    </b-navbar>
    <div>
      <loading color="#fd7e14" :active.sync="isLoading"></loading>
    </div>
    <b-form @submit="onSubmit" @reset="onReset" v-if="show">
      <p class="mt-3 font-weight-bold">
        捐款項目：{{ data.donaToName }} /
        {{ data.donaItemName }}
      </p>
      <p class="font-weight-bold">捐款金額：{{ formatPrice }} 元</p>
      <!-- 姓名 -->
      <b-row class="mb-4">
        <b-col sm="2">
          <label class="font-weight-bold mb-0" for="input-default">
            捐款人姓名
            <label class="text-required mb-0">(必填)</label>：(收據抬頭)
          </label>
        </b-col>
        <b-col sm="10">
          <b-input
            id="inline-form-input-name"
            class="mb-2 mr-sm-2 mb-sm-0"
            placeholder="請輸入姓名(僅限填寫一位)"
            v-model="data.name"
            :state="checkname"
            maxlength="60"
            required
          ></b-input>
        </b-col>
      </b-row>
      <!-- 身分證字號 -->
      <b-row class="mb-2">
        <b-col sm="2">
          <label for="input-default" class="font-weight-bold mb-0">
            身分證字號
            <label class="text-required mb-0">(必填)</label>：(會員辨識用)
          </label>
        </b-col>
        <!-- 選擇全碼或末４碼 -->
        <b-col sm="3">
          <b-form-select
            v-model="useridType"
            :options="idtypeOptions"
            :state="idTypeState"
          >
          </b-form-select>
        </b-col>
      </b-row>
      <!-- 全碼 -->
      <b-row
        :class="[useridType == 'ten' && checkTenShowError ? 'mb-4' : 'mb-0']"
        v-if="useridType == 'ten'"
      >
        <b-col sm="2"></b-col>
        <b-col sm="10">
          <b-input
            id="inline-form-input-name"
            class="mb-2 mr-sm-2 mb-sm-0"
            placeholder="請輸入身分證字號"
            v-model="data.sin"
            :state="checkTen"
            maxlength="10"
            required
          ></b-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="2"></b-col>
        <b-col
          sm="10"
          class="text-required mb-3"
          v-if="useridType == 'ten' && !checkTenShowError"
          >請檢查身分證字號格式是否正確</b-col
        >
      </b-row>
      <!-- 末４碼 -->
      <b-row
        :class="[useridType == 'four' && checkFourShowError ? 'mb-4' : 'mb-0']"
        v-if="useridType == 'four'"
      >
        <b-col sm="2"></b-col>
        <b-col sm="10">
          <b-input
            id="inline-form-input-name"
            class="mb-2 mr-sm-2 mb-sm-0"
            placeholder="請輸入身分證字號末四碼"
            v-model="data.sinLast4"
            :state="checkFour"
            maxlength="4"
            required
          ></b-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="2"></b-col>
        <b-col
          sm="10"
          class="text-required mb-3"
          v-if="useridType == 'four' && !checkFourShowError"
          >請檢查身分證字號格式是否正確</b-col
        >
      </b-row>
      <!-- 手機號碼 -->
      <b-row :class="[!checkCellphoneShowError ? 'mb-0' : 'mb-4']">
        <b-col sm="2">
          <label for="input-default" class="font-weight-bold mb-0">
            手機號碼
            <label class="text-required mb-0">(必填)</label>：
          </label>
        </b-col>
        <b-col sm="10">
          <b-form-input
            placeholder="請輸入手機號碼"
            class="mb-2 mr-sm-2 mb-sm-0"
            v-model="data.cellPhone"
            :state="checkCellphone"
            required
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row v-if="!checkCellphoneShowError">
        <b-col sm="2"></b-col>
        <b-col sm="10" class="text-required mb-3"
          >請檢查手機號碼格式是否正確</b-col
        >
      </b-row>
      <!-- 住家電話 -->
      <b-row class="mb-4">
        <b-col sm="2">
          <label class="font-weight-bold mb-0" for="input-default"
            >住家電話：</label
          >
        </b-col>
        <b-col>
          <b-form-input
            placeholder="請輸入住家電話"
            v-model="data.homePhone"
            :state="checkHomePhone"
          ></b-form-input>
        </b-col>
      </b-row>
      <!-- 電子信箱 -->
      <b-row class="mb-4">
        <b-col sm="2">
          <label class="font-weight-bold mb-0" for="input-default"
            >電子信箱：</label
          >
        </b-col>
        <b-col>
          <b-form-input
            placeholder="請輸入電子信箱"
            v-model="data.email"
            :state="checkEmail"
          ></b-form-input>
        </b-col>
      </b-row>
      <!-- 是否為廣論學員 -->
      <div class="mb-4">
        <b-row>
          <b-col sm="2">
            <label class="font-weight-bold mb-0">
              參加過福智廣論研討班？
              <label class="text-required mb-0">(必填)</label>：
            </label>
          </b-col>
          <b-col sm="2" md="3">
            <b-form-select
              v-model="data.payerTypeCode"
              :options="payerOptions"
              :state="LRstate"
              required
            >
              <template v-slot:first>
                <b-form-select-option :value="null" disabled>
                  -- 請選擇 --
                </b-form-select-option>
              </template>
            </b-form-select>
          </b-col>
        </b-row>
      </div>
      <!-- 性別 -->
      <div class="mb-4">
        <b-row>
          <b-col sm="2">
            <label class="font-weight-bold mb-0">
              性別
              <label class="text-required mb-0">(必填)</label>：
            </label>
          </b-col>
          <b-col sm="2" md="3">
            <b-form-select
              v-model="data.genderTypeCode"
              :options="genderOptions"
              :state="genderState"
            >
              <template v-slot:first>
                <b-form-select-option :value="null" disabled>
                  -- 請選擇 --
                </b-form-select-option>
              </template>
            </b-form-select>
          </b-col>
        </b-row>
      </div>
      <!-- 是否要收據 -->
      <div class="mb-4">
        <b-row>
          <b-col sm="2">
            <label class="font-weight-bold mb-0">
              是否需要收據
              <label class="text-required mb-0">(必填)</label>：(收據寄送資訊)
            </label>
          </b-col>
          <b-col sm="2" md="3">
            <b-form-select
              v-model="data.receiptTypeCode"
              :options="receiptOptions"
              :state="receiptState"
            >
              <template v-slot:first>
                <b-form-select-option :value="null" disabled>
                  -- 請選擇 --
                </b-form-select-option>
              </template>
            </b-form-select>
          </b-col>
        </b-row>
      </div>

      <!-- 不需收據時，填寫縣市 -->
      <div class="address" v-if="data.receiptTypeCode != 'BY_TIME'">
        <!-- 縣市 -->
        <b-row class="mb-4">
          <b-col sm="2">
            <label class="font-weight-bold mb-0"
              >居住地：(區域性活動通知用)</label
            >
          </b-col>
          <b-col>
            <b-form-select
              v-model="data.address.city"
              :options="cityOptions"
              v-on:change="getDistrict"
            ></b-form-select>
          </b-col>
        </b-row>
      </div>
      <!-- 要收據必填地址 -->
      <div class="address" v-if="data.receiptTypeCode == 'BY_TIME'">
        <div>
          <b-row class="mb-0" no-gutters>
            <b-col cols="5">
              <label class="font-weight-bold mb-0" for="input-default"
                >收據抬頭：</label
              >
            </b-col>
            <b-col cols="7" class="text-right">
              <b-form-checkbox
                v-model="isEqName"
                v-on:input="checkEqName"
                value="true"
                unchecked-value="false"
              >
                等同捐款人姓名
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col>
              <b-form-input
                placeholder="請輸入收據抬頭"
                v-model="data.donatorName"
                :state="checkDonatorName"
                :disabled="isEqName == 'true'"
                required
              ></b-form-input>
            </b-col>
          </b-row>
        </div>
        <!-- 收據抬頭身分證 -->
        <div v-if="this.data.amount >= 500000">
          <div class="mb-3">
            <b-row>
              <b-col sm="2">
                <label class="font-weight-bold">
                  收據抬頭為個人或公司
                </label>
              </b-col>
              <b-col sm="2" md="3">
                <b-form-select
                  :disabled="isEqName == 'true'"
                  v-model="data.donatorTypeCode"
                  :options="donatorTypeOptions"
                >
                </b-form-select>
              </b-col>
            </b-row>
          </div>

          <b-row class="mb-3" no-gutters>
            <b-col>
              <label
                class="mt-2 font-weight-bold"
                for="input-default"
                v-if="data.donatorTypeCode == 'PERSON'"
                >收據抬頭身分證字號：</label
              >
              <label class="mt-2 font-weight-bold" for="input-default" v-else
                >收據抬頭統編：</label
              >
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col v-if="data.donatorTypeCode == 'PERSON'">
              <b-form-input
                placeholder="收據抬頭身分證字號"
                v-model="data.donatorSin"
                :state="checkDonatorSin"
                :disabled="isEqName == 'true'"
                required
              ></b-form-input>
            </b-col>
            <b-col v-else>
              <b-form-input
                placeholder="收據抬頭統編"
                v-model="data.donatorSinCompany"
                :state="checkDonatorSinCompany"
                required
              ></b-form-input>
            </b-col>
          </b-row>
        </div>

        <!-- 收據寄送至 -->
        <div class="mb-4" v-if="data.receiptTypeCode == 'BY_TIME'">
          <label class="font-weight-bold mb-1">
            收據寄送至
            <label class="text-required mb-0">(必填)</label>：
          </label>
          <div>
            <!-- 縣市 -->
            <b-row class="mb-3">
              <b-col sm="2">
                <label class="font-weight-bold mb-0">縣市：</label>
              </b-col>
              <b-col>
                <b-form-select
                  v-model="data.address.city"
                  :options="cityOptions"
                  v-on:change="getDistrict"
                  required
                ></b-form-select>
              </b-col>
            </b-row>
            <!-- 鄉鎮市區 -->
            <b-row class="mb-3">
              <b-col sm="2">
                <label class="font-weight-bold mb-0">鄉鎮市區：</label>
              </b-col>
              <b-col>
                <b-form-select
                  v-model="data.address.district"
                  :options="districtOptions"
                  v-on:change="getRoadList"
                  required
                ></b-form-select>
              </b-col>
            </b-row>
            <!-- 路街村里 -->
            <b-row class="mb-3">
              <b-col sm="2">
                <label class="font-weight-bold mb-0">路街村里：</label>
              </b-col>
              <b-col>
                <b-form-select
                  v-model="data.address.road"
                  :options="roadOptions"
                  v-on:change="getRoadZipCode"
                  required
                ></b-form-select>
              </b-col>
            </b-row>
            <!-- 郵遞區號 -->
            <b-row class="mb-3">
              <b-col sm="2" cols="5">
                <label class="font-weight-bold mb-0">郵遞區號：</label>
              </b-col>
              <b-col cols="7" class="p-0 d-flex" align-self="center"
                ><b-badge variant="light">{{
                  data.address.zipCode
                }}</b-badge></b-col
              >
            </b-row>
            <!-- 巷弄 -->
            <b-row>
              <b-col cols="5" class="address-input">
                <b-form-input v-model="data.address.lane"></b-form-input>
              </b-col>
              <b-col cols="1" class="ad-small-label font-weight-bold">巷</b-col>
              <b-col cols="5" class="address-input">
                <b-form-input v-model="data.address.alley"></b-form-input>
              </b-col>
              <b-col cols="1" class="ad-small-label font-weight-bold">弄</b-col>
            </b-row>
            <b-row>
              <b-col cols="5" class="address-input">
                <b-form-input v-model="data.address.subAlley"></b-form-input>
              </b-col>
              <b-col cols="1" class="ad-small-label font-weight-bold">衖</b-col>
              <b-col cols="5" class="address-input">
                <b-form-input v-model="data.address.number"></b-form-input>
              </b-col>
              <b-col cols="1" class="ad-small-label font-weight-bold">號</b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col cols="5" class="address-input">
                <b-form-input v-model="data.address.floor"></b-form-input>
              </b-col>
              <b-col cols="1" class="ad-small-label font-weight-bold">樓</b-col>
              <b-col cols="5" class="address-input">
                <b-form-input v-model="data.address.room"></b-form-input>
              </b-col>
              <b-col cols="1" class="ad-small-label font-weight-bold">室</b-col>
            </b-row>
            <label>備註：請含有○○之○的巷、弄、號地址，以○○-○方式輸入</label>
            <br />
            <label>如：88之10號→88-10號</label>
          </div>
        </div>
      </div>
      <!-- 說明 -->
      <!-- <b-card-group deck> -->
      <b-card
        header="捐款注意事項"
        header-bg-variant="primary"
        header-tag="header"
        header-text-variant="light font-weight-bold"
      >
        <b-form-checkbox
          id="checkbox-1"
          v-model="data.isAcceptPdpa"
          name="checkbox-1"
          value="accept"
          unchecked-value="reject"
          class="text-left pb-4"
          >我同意遵守本網站個人<u>
            <b-link v-b-modal.dona-notice-detail class="font-weight-bold"
              >捐款注意事項</b-link
            > </u
          >及其他有關著作權、版權、商標專用權、網路智慧財產權等之法律規定。
          <!-- <b-button>Launch demo modal</b-button> -->

          <b-modal
            id="dona-notice-detail"
            size="xl"
            title="捐款注意事項"
            scrollable
          >
            <p style="text-align: justify;">
              <strong>歡迎使用虛擬帳號捐款回報系統</strong>
            </p>
            <p style="text-align: justify;">
              感恩您使用{{
                data.donaToFullName
              }}捐款服務系統，本系統係採用電子資料處理慣例，包括防火牆及安全傳輸層（SSL），以保護您個人資料的隱密性。
            </p>
            <p style="text-align: justify;"><strong>注意事項：</strong></p>
            <p style="text-align: justify;">
              1. 請您詳閱各項表格欄位，並確實填寫，以確保您的愛心/善心受到保護。
            </p>
            <p style="text-align: justify;">
              2. 您的捐款，將由{{
                data.donaToFullName
              }}開立捐款收據，由福智傳心提供捐款系統與服務。
            </p>
            <p style="text-align: justify;">
              3. 捐款收據只限台灣地區，得作扣抵所得稅使用。
            </p>
            <p style="text-align: justify;">
              4.
              您所捐的每筆款項，將在您捐款後的一個月內，寄送收據至您所填寫的聯絡地址。
            </p>
            <p style="text-align: justify;">
              5. 若有任何問題，請您聯繫<a href="mailto:service@bwbyheart.org"
                >service@bwbyheart.org</a
              >。
            </p>
            <p style="text-align: justify;">
              本人瞭解已詳閱、知悉上開注意事項，並同意貴會及福智傳心(財團法人高雄市橋頭區福智寺)基於贈與契約關係、法定義務及募款等目的，蒐集、處理及利用本人提供之下列個人資料。本人亦瞭解本人得自由選擇是否提供全部或部份個人資料，如拒絕提供或提供不實，可能影響本人之相關權益（包括但不限於收據開立寄送、所得稅扣抵等）。
            </p>
            <template v-slot:modal-footer="{ ok }">
              <b-button size="sm" variant="primary" @click="ok()">
                確定
              </b-button>
            </template>
          </b-modal>
        </b-form-checkbox>
        <!-- update 2022/06/22 文玲、嘉慧與客戶討論後，下班前提出來需求，將此處隱藏 -->
        <!-- <div class="p-4 text-left alert-section">
          <b-card-text>
            依財團法人法第25條規定，除捐贈者事先書面表示反對外，各財團法人均需主動公開捐贈者之「姓名」及「捐款金額」，詳見<u>
              <b-link
                class="font-weight-bold"
                href="https://www.blisswisdom.org/donate/qanda#q2"
                >捐款徵信說明</b-link
              >
            </u>
          </b-card-text>
        </div> -->
      </b-card>
      <!-- </b-card-group> -->
      <!-- 說明 -->
      <b-row class="mb-5 mt-4">
        <b-col class="text-right mb-3">
          <b-button
            pill
            type="submit"
            variant="primary"
            class="left-btn text-light"
            :disabled="isSubmitDisabled"
            >送出</b-button
          >
        </b-col>
        <b-col class="text-left mb-3">
          <b-button pill type="reset" variant="outline-danger" class="rigth-btn"
            >重設</b-button
          >
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>
<script>
  import { isNullOrUndefined } from "util";
  import { RoadFunctions } from "../services/RoadFunctions";
  import { CheckFunctions } from "../services/CheckFunctions";
  export default {
    name: "DonationReplyPage",
    data() {
      return {
        // api url 版本網址
        url: "webDona/v12/",
        data: {
          uuid: null,
          amount: null,
          name: null,
          sin: null,
          sinLast4: null,
          cellPhone: null,
          email: null,
          homePhone: null,
          payerTypeCode: null, // 是否廣論學員
          genderTypeCode: null, //性別
          receiptTypeCode: "UNWANTTED", //是否需要收據
          donatorName: null,
          donatorSin: null,
          donatorTypeCode: "PERSON",
          address: {
            addressType: "TAIWAN",
            city: null,
            district: null,
            road: null,
            lane: null, // 巷
            alley: null, // 弄
            subAlley: null, //衖
            number: null, //號
            floor: null, //樓
            room: null, //室
            zipCode: "", //郵遞區號
            other: null,
          },
          isAcceptPdpa: "reject",
          // 捐款細項數據 及 受贈單位數據
          donaItemId: null,
          donaItemName: null,
          donaUseName: null,
          donaToName: null,
          donaToFullName: null,
        },
        isLoading: false,
        show: false,
        payerOptions: [
          { text: "正在參加", value: "YES" },
          { text: "曾經參加過", value: "EVER" },
          { text: "沒聽過", value: "NOT_HEARD" },
          { text: "沒有", value: "NO" },
        ],
        genderOptions: [
          { text: "男", value: "MALE" },
          { text: "女", value: "FEMALE" },
        ],
        useridType: "ten", //身分證全碼or4碼
        idtypeOptions: [
          { text: "全碼", value: "ten" },
          { text: "後４碼", value: "four" },
        ],
        receiptOptions: [
          { text: "是", value: "BY_TIME" },
          { text: "否", value: "UNWANTTED" },
        ],
        donatorTypeOptions: [
          { text: "個人", value: "PERSON" },
          { text: "公司", value: "CORPORATION" },
        ],
        cityOptions: [],
        districtOptions: [{ value: null, text: "請選擇" }],
        roadOptions: [{ value: null, text: "請選擇" }],
        isEqName: "false",
        //  初始資料
        originalData: {
          uuid: null,
          amount: null,
          cellPhone: null,
        },
      };
    },
    created() {
      // this.show = true;
      // return
      this.isLoading = true;
      let uuid = this.$route.query.uuid;
      console.info("uuid:" + JSON.stringify(this.$route.query.uuid));
      if (isNullOrUndefined(uuid)) {
        this.show = false;
        this.isLoading = false;
        this.$root.errorMessage = "查無此頁";
        this.$router.replace({ name: "ERROR" });
        return;
      }
      this.cityOptions = RoadFunctions.getCity(); //取得縣市
      this.$http
        .get(`${this.url}getWebDona?uuid=${uuid}`)
        .then((res) => {
          // res.preventDefault();
          console.log(JSON.stringify(res.body));
          let body = res.body;
          if (body.message != undefined) {
            this.$nextTick(() => {
              this.show = false;
              this.isLoading = false;
              this.$root.errorMessage = body.message;
              this.$router.replace({ name: "ERROR" });
            });
          } else {
            this.data.uuid = body.uuid;
            this.data.amount = body.amount;
            this.data.cellPhone = body.cellPhone;
            this.data.donaItemId = body.donaItemId;
            this.data.donaItemName = body.donaItemName;
            this.data.donaUseName = body.donaUseName;
            this.data.donaToName = body.donaToName;
            this.data.donaToFullName = body.donaToFullName;
            this.originalData = body;
            // console.log("originalData:" + JSON.stringify(this.originalData));
            this.show = true;
            this.isLoading = false;
          }
        })
        .catch((e) => {
          this.$nextTick(() => {
            this.show = false;
            this.isLoading = false;
            this.$root.errorMessage = "讀取失敗";
            this.$router.replace({ name: "ERROR" });
          });
        });
    },
    methods: {
      onSubmit(evt) {
        evt.preventDefault();
        if (this.useridType == "ten") {
          if (!this.checkTen) {
            console.log("checkTen false" + this.checkTen);
            this.$dialog.alert("請檢查身分證欄位格式", {
              html: true,
              okText: "好",
            });

            return;
          }
          this.data.sinLast4 = this.data.sin.substr(6, 4);
        } else {
          if (!this.checkFour) {
            console.log("checkFour false" + this.checkTen);
            this.$dialog.alert("請檢查身分證後四碼欄位格式", {
              html: true,
              okText: "好",
            });

            return;
          }
          this.data.sin = null;
        }
        if (
          !this.checkname ||
          !this.checkCellphone ||
          !(isNullOrUndefined(this.checkHomePhone) || this.checkHomePhone) ||
          !(isNullOrUndefined(this.checkEmail) || this.checkEmail)
        ) {
          console.log("check false");
          this.$dialog.alert("請檢查欄位格式", { html: true, okText: "好" });
          return;
        }
        if (
          this.data.receiptTypeCode != "UNWANTTED" &&
          !this.checkDonatorName
        ) {
          console.log("checkDonatorName false");
          this.$dialog.alert("請檢查欄位格式", { html: true, okText: "好" });
          return;
        }
        if (
          this.data.receiptTypeCode != "UNWANTTED" &&
          this.data.amount >= 500000
        ) {
          if (!this.checkDonatorSin) {
            console.log("checkDonatorName and checkDonatorSin false");
            if (this.isEqName)
              this.$dialog.alert("請檢查本人身分證字號全碼", {
                html: true,
                okText: "好",
              });
            else
              this.$dialog.alert("請檢查收據抬頭身分證字號欄位", {
                html: true,
                okText: "好",
              });
            return;
          }
          if (!this.checkDonatorSinCompany) {
            console.log("checkDonatorName and checkDonatorSin false");
            this.$dialog.alert("請檢查收據抬頭統編欄位", {
              html: true,
              okText: "好",
            });
            return;
          }
        }
        if (this.data.receiptTypeCode == "UNWANTTED") {
          this.data.donatorName = this.data.name;
          let city = this.data.address.city;
          if (isNullOrUndefined(city)) {
            this.data.address = null;
          } else {
            this.data.address = {
              addressType: "TAIWAN",
              city: city,
              district: null,
              road: null,
              lane: null, // 巷
              alley: null, // 弄
              subAlley: null, //衖
              number: null, //號
              floor: null, //樓
              room: null, //室
              zipCode: null, //郵遞區號
              other: null,
            };
          }
        }

        // console.log(JSON.stringify(this.data));
        // // TODO: test
        // console.log("onSubmit");
        // return;
        this.isLoading = true;
        // 資料預處理，將姓名、收據抬頭 清掉前後[空白]
        this.data.name = this.data.name.trim();
        this.data.donatorName = this.data.donatorName.trim();
        // 呼叫 送出api
        this.$http
          .post(`${this.url}create`, this.data, {
            "Content-Type": "application/json",
          })
          .then((res) => {
            console.log(JSON.stringify(res));
            let body = res.body;

            if (body.message != undefined) {
              this.$nextTick(() => {
                this.isLoading = false;
                if (body.message.includes(":")) {
                  let t = body.message.split(":")[0];
                  let c = body.message.split(":")[1];
                  this.$dialog.alert(
                    {
                      title: t,
                      body: c,
                    },
                    { html: true, okText: "好" }
                  );
                  this.data.address = {
                    addressType: "TAIWAN",
                    city: null,
                    district: null,
                    road: null,
                    lane: null, // 巷
                    alley: null, // 弄
                    subAlley: null, //衖
                    number: null, //號
                    floor: null, //樓
                    room: null, //室
                    zipCode: "", //郵遞區號
                    other: null,
                  };
                } else {
                  this.show = false;
                  this.$root.errorMessage = body.message;
                  this.$router.replace({ name: "ERROR" });
                }
              });
            }
          })
          .catch((e) => {
            this.$nextTick(() => {
              this.show = false;
              this.isLoading = false;
              this.$root.errorMessage = "讀取失敗";
              this.$router.replace({ name: "ERROR" });
            });
          });
      },
      onReset(evt) {
        evt.preventDefault();
        // Trick to reset/clear native browser form validation state
        this.show = false;
        this.$nextTick(() => {
          this.show = true;
          this.data = {
            uuid: this.originalData.uuid,
            amount: this.originalData.amount,
            name: null,
            sin: null,
            sinLast4: null,
            cellPhone: this.originalData.cellPhone,
            email: null,
            homePhone: null,
            payerTypeCode: null, // 是否廣論學員
            genderTypeCode: null, //性別
            receiptTypeCode: "UNWANTTED", //是否需要收據
            address: {
              addressType: "TAIWAN",
              city: null,
              district: null,
              road: null,
              lane: null, // 巷
              alley: null, // 弄
              subAlley: null, //衖
              number: null, //號
              floor: null, //樓
              room: null, //室
              zipCode: "", //郵遞區號
              other: null,
            },
            isAcceptPdpa: "reject",
            donaItemId: this.originalData.donaItemId,
            donaItemName: this.originalData.donaItemName,
            donaUseName: this.originalData.donaUseName,
            donaToName: this.originalData.donaToName,
            donaToFullName: this.originalData.donaToFullName,
          };
        });
      },
      //取得鄉鎮市區
      getDistrict: function() {
        if (isNullOrUndefined(this.data.address.city)) {
          this.districtOptions = [{ value: null, text: "請選擇" }];
          this.data.address.district = null;
          this.roadOptions = [{ value: null, text: "請選擇" }];
          this.data.address.road = null;
          this.data.address.zipCode = null;
          return;
        }
        this.$nextTick(() => {
          this.districtOptions = RoadFunctions.getDistrict(
            this.data.address.city
          );
          this.data.address.district = null;
          this.roadOptions = [{ value: null, text: "請選擇" }];
          this.data.address.road = null;
          this.data.address.zipCode = null;
        });
      },
      //取得路街村里名
      getRoadList() {
        if (
          isNullOrUndefined(this.data.address.city) ||
          isNullOrUndefined(this.data.address.district)
        ) {
          this.roadOptions = [{ value: null, text: "請選擇" }];
          this.data.address.road = null;
          this.data.address.zipCode = null;
          return;
        }
        this.$nextTick(() => {
          this.roadOptions = RoadFunctions.getRoadList(
            this.data.address.city,
            this.data.address.district
          );
          this.data.address.road = null;
          this.data.address.zipCode = null;
        });
      },
      //選擇 路街村里名
      getRoadZipCode: function(value) {
        console.log("value : " + value);
        if (isNullOrUndefined(value)) {
          this.data.address.zipCode = null;
          return;
        }
        this.$nextTick(() => {
          this.data.address.zipCode = RoadFunctions.getRoadZipCode(
            this.data.address.city,
            this.data.address.district,
            this.data.address.road
          );
        });
      },
      checkEqName() {
        console.log("checkEqName" + this.isEqName);
        if (this.isEqName == "true") {
          this.data.donatorName = this.data.name;
          this.data.donatorSin = this.data.sin;
          this.data.donatorTypeCode = "PERSON";
        } else {
          this.data.donatorName = "";
        }
        return true;
      },
    },
    computed: {
      checkname() {
        if (isNullOrUndefined(this.data.name)) return null;
        else {
          return (
            this.data.name.trim().length >= 2 &&
            this.data.name.trim().length <= 20
          );
        }
      },
      checkDonatorName() {
        if (isNullOrUndefined(this.data.donatorName)) return null;
        else {
          return (
            this.data.donatorName.trim().length >= 2 &&
            this.data.donatorName.trim().length <= 30
          );
        }
      },
      checkDonatorSin() {
        if (this.data.amount < 500000 || this.data.donatorTypeCode != "PERSON")
          return true;
        if (isNullOrUndefined(this.data.donatorSin)) return null;
        else if (this.data.donatorSin.length != 10) return false;
        return CheckFunctions.checkSin(this.data.donatorSin);
      },
      checkDonatorSinCompany() {
        if (
          this.data.amount < 500000 ||
          this.data.donatorTypeCode != "CORPORATION"
        )
          return true;
        if (isNullOrUndefined(this.data.donatorSinCompany)) return null;
        return CheckFunctions.checkFein(this.data.donatorSinCompany);
      },
      checkTen() {
        if (isNullOrUndefined(this.data.sin)) return null;
        else if (this.data.sin.length != 10) return false;
        return CheckFunctions.checkSin(this.data.sin);
      },
      checkTenShowError() {
        if (isNullOrUndefined(this.data.sin)) return true;
        return CheckFunctions.checkSin(this.data.sin);
      },
      checkFour() {
        let reg = new RegExp(/^\d{4}$/);
        if (isNullOrUndefined(this.data.sinLast4)) return null;
        else return reg.test(this.data.sinLast4);
      },
      checkFourShowError() {
        let reg = new RegExp(/^\d{4}$/);
        if (isNullOrUndefined(this.data.sinLast4)) return true;
        else return reg.test(this.data.sinLast4);
      },
      LRstate() {
        return Boolean(this.data.payerTypeCode);
      },
      genderState() {
        return Boolean(this.data.genderTypeCode);
      },
      receiptState() {
        return Boolean(this.data.receiptTypeCode);
      },
      idTypeState() {
        return Boolean(this.useridType);
      },
      checkCellphone() {
        if (isNullOrUndefined(this.data.cellPhone)) return null;
        else if (!Boolean(this.data.cellPhone)) return false;
        else return CheckFunctions.checkCellPhone(this.data.cellPhone);
      },
      checkCellphoneShowError() {
        if (isNullOrUndefined(this.data.cellPhone)) return true;
        else return CheckFunctions.checkCellPhone(this.data.cellPhone);
      },
      checkHomePhone() {
        if (!Boolean(this.data.homePhone)) return null;
        else return CheckFunctions.checkHomePhone(this.data.homePhone);
      },
      checkEmail() {
        if (!Boolean(this.data.email)) return null;
        else {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.data.email = this.data.email.toLowerCase();
          return CheckFunctions.checkEmail(this.data.email);
        }
      },
      formatPrice() {
        return this.data.amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      isSubmitDisabled() {
        return this.data.isAcceptPdpa === "reject" ? true : false;
      },
      checkClassRoom() {
        if (isNullOrUndefined(this.data.address.other)) return null;
        else return this.data.address.other.length >= 2;
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .left-btn {
    margin-right: 8px;
  }
  .right-btn {
    margin-left: 8px;
  }
  .address-input {
    margin-bottom: 3px;
  }

  .ad-small-label {
    padding-top: 5px;
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .text-required {
    color: red !important;
  }
  .alert-section {
    background-color: #fdfcf5;
    border: 1px solid transparent;
    border-color: #faebcc;
    border-radius: 4px;
  }
</style>
